// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"303ba48a","244":"c044a874","374":"2748d662","453":"99dcf01f","623":"de36d9fe","745":"5e58a8d5","769":"ee79c822","989":"c4813d59"}[chunkId] + ".chunk.js";
};